export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Ecosystem", id: "ecosystem" },
  { label: "AI Trading", id: "ai-trading" },
  { label: "WIN Token", id: "win-token" },
  { label: "Roadmap", id: "roadmap" },
  { label: "About", id: "about" },
];
